import React from 'react';
import Menu from '../components/Menu.js';
import TextBlock from '../components/TextBlock.js';
import '../styles/index.css';

export default function About() {
	let text = require('../txt/AboutTxt.json');
	var num = 4;

	return(
		<div className="container text">
			<Menu />
			<div className="item">
				{text.map((elt) => {
						num+= 1;
						return (<div>
								<div className="flower-container">
									<img 
										alt={'bitmap flower'}
										src={require('/public/flowers/' + num + '.png')}
										className={'flower'}
									/>
									<br />
								</div>
								<div className="text-container">
									<TextBlock
										subtitle={elt.subtitle}
										mainText={elt.mainText}
									/>
								</div>
							</div>
						);
				})}
				<div id="contact-img-container">
					<img 
						src={require('../img/contact-2.jpg')} 
						className="contact-img"
					/>
					<img 
						src={require('../img/contact-1.jpg')} 
						className="contact-img"
					/>
				</div>
				<div>
					<a href="https://instagram.com/erye.film" target="_blank" className="ig-icon">
						<img 
							alt={'Instagram logo'}
							src={require('../img/ig.png')}
						/>
					</a>
				</div>
			</div>
		</div>
	);
}